'use client';

import Link from 'next/link';
import { usePathname } from 'next/navigation';
import scroll from '@/assets/styles/scroll.module.scss';
import { useEffect } from 'react';

const tabs = [
  {
    id: 1,
    title: 'manpower',
    href: '/features/features-help',
  },
  {
    id: 2,
    title: 'equipment',
    href: '/features/features-help/equipment',
  },
  {
    id: 3,
    title: 'progress',
    href: '/features/features-help/progress',
  },
  {
    id: 4,
    title: 'budget',
    href: '/features/features-help/budget',
  },
  {
    id: 5,
    title: 'missionControl',
    href: '/features/features-help/mission-control',
  },
  {
    id: 6,
    title: 'form',
    href: '/features/features-help/form',
  },
];

function FeatureTab({ t, lang }) {
  const path = usePathname();
  return (
    <section className="bg-[#F6F4F2] px-7 py-6 2xl:-mx-[calc((100vw-1280px-8px)/2)]">
      <h2 className="text-center text-lg md:text-3xl md:font-600">
        {t.featureTabTitle}...
      </h2>
      <div className={`${scroll.overflow_auto} overflow-x-auto`}>
        <ul className="relative flex w-full items-center gap-2 py-2 md:justify-center">
          {tabs.map((tab, index) => (
            <li key={tab.id} className="relative z-10 bg-[#F6F4F2]">
              <Link
                href={`/${lang}${tab.href}`}
                className="flex items-center gap-2"
              >
                <p
                  className={`whitespace-nowrap ${
                    `/${lang}${tab.href}` === path
                      ? 'text-gray-900 md:font-600'
                      : 'text-gray-800 hover:text-gray-900'
                  } `}
                >
                  {t[tab.title] ?? tab.title}
                  {`/${lang}${tab.href}` === path ? (
                    <span className="inset-0 block h-1 w-full -skew-x-[20deg] bg-secondary-500" />
                  ) : null}
                </p>
                {index !== tabs.length - 1 && (
                  <span className="block h-[2px] w-5 cursor-default bg-gray-600" />
                )}
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}

export default FeatureTab;
